/** The tuple a signature placement is unique on, on every path: PDF box, Word anchor, instance row. */
export interface SignatureSlotTuple {
	signingRoleId: string;
	isWitness: boolean;
	signatureIndex: number;
}

/**
 * The one string form of a signature slot, and the value `DocumentPlacement.slotKey` stores for a
 * SIGNATURE row. Changing the format needs a data migration that rewrites every stored key.
 */
export const signatureSlotKey = (slot: SignatureSlotTuple): string =>
	`${slot.signingRoleId}:${slot.isWitness ? 'w' : 'p'}:${slot.signatureIndex}`;
